import { useEffect, useState } from 'react'
import Form, {
  Input,
  Select,
  Textarea
} from '../../../../../../components/Form'
import { useHistory } from 'react-router-dom'
import { useToast } from '../../../../../../hooks/toast'
import { useLoading } from '../../../../../../hooks/loading'
import { useUpdateDataTable } from '../../../../../../hooks/dataTable'
import { apiCreate, apiUpdate } from '../../domain/api'
import {
  INGREDIENT_PRICE_MEASURE_OPTIONS,
  INGREDIENT_TYPES_MAP,
  nameActions
} from '../../domain/info'
import { FormContainer, InputContainer } from './styles'
import { deleteEmptyFields } from 'utlis/deleteEmptyFields'
import api from 'services/api'
import currency from 'currency.js'
import {
  genericMaskWithTwoZero,
  genericMaskWithTwoZeroWithPoint
} from 'utlis/mask'

const BRL = (value: string) =>
  currency(value, {
    decimal: ',',
    symbol: ''
  })

type TypesFormProps = {
  initialValues?: IIngredient & {
    idUpdate: number
  }
  typeForm: 'create' | 'update'
}

export const FormIngredient = ({
  initialValues,
  typeForm
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const { updateDataTable } = useUpdateDataTable()
  const [hasUpdated, setHasUpdated] = useState<boolean>(false)
  const [defaultValues, setDefaultValues] = useState<IIngredient>()
  const [correctionPercentage, setCorrectionPercentage] = useState('0,00')
  const [priceInput, setPriceInput] = useState('')
  const [unitMeasure, setUnitMeasure] = useState<INGREDIENT_TYPES>()
  const [priceMeasure, setPriceMeasure] = useState('')

  useEffect(() => {
    if (initialValues && !hasUpdated) {
      setDefaultValues({
        ...initialValues
      })
      setCorrectionPercentage(
        BRL(
          genericMaskWithTwoZero(initialValues.correction_percentage || '0,00')
        ).format()
      )
      if (initialValues.price) {
        setPriceInput(
          BRL(
            genericMaskWithTwoZeroWithPoint(
              String(initialValues.price).replace('.', ',')
            )
          ).format()
        )
      }
      setUnitMeasure(initialValues.unit_measure)
      setPriceMeasure(initialValues.price_measure || '')
    }
  }, [initialValues, hasUpdated])

  const { activeLoading, disableLoading } = useLoading()

  const onSubmitForm = async (data: IIngredient) => {
    const id = initialValues?.idUpdate
    data = deleteEmptyFields(data)

    const price = priceInput ? BRL(priceInput).value : undefined

    try {
      if (typeForm === 'create') {
        try {
          const dataCreate = {
            ...data,
            correction_percentage: BRL(correctionPercentage).value,
            price,
            price_measure: priceMeasure || undefined
          }

          activeLoading()
          await api.post(apiCreate(), dataCreate)
          updateDataTable()
          disableLoading()
          addToast({
            type: 'success',
            title: 'Registro criado',
            description: 'Registro criado com sucesso'
          })
          history.push(nameActions.read.to)
        } catch (err: any) {
          const messsageError = err.response.data.message
          console.log(messsageError, 'here')
          addToast({
            type: 'error',
            title: 'Erro ao adicionar o registro',
            description:
              messsageError ||
              'Ocorreu um erro ao fazer o cadastro, por favor, tente novamente.'
          })
          updateDataTable()
          disableLoading()
        }
      } else {
        const dataUpdate = {
          ...data,
          correction_percentage: BRL(correctionPercentage).value,
          price,
          price_measure: priceMeasure || undefined
        }
        try {
          activeLoading()
          const res = await api.put(apiUpdate(String(id)), dataUpdate)
          setDefaultValues(res.data)
          updateDataTable()
          setHasUpdated(true)
          disableLoading()

          history.push(nameActions.read.to)
          addToast({
            type: 'success',
            title: 'Registro atualizado',
            description: 'Registro alterado com sucesso'
          })
        } catch (err: any) {
          history.push(nameActions.read.to)
          console.log(err.response.data, 'here')

          addToast({
            type: 'error',
            title: 'Erro ao atualizar o registro',
            description:
              'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
          })
        }
      }
      disableLoading()
    } catch (err) {
      if (typeForm === 'create') {
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description:
            'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
        })
      }
    }
  }

  return (
    <Form
      onSubmit={onSubmitForm}
      setReset
      defaultValues={{
        ...defaultValues
      }}
    >
      <>
        <div className="card mb-5 mb-xl-10">
          <FormContainer className="form-body">
            <div className="row">
              <Input
                name="name"
                className="col-md-4"
                rules={{ required: true }}
                label="Nome"
              />
            </div>
            <div className="row">
              <Select
                className=" col-md-3"
                name="unit_measure"
                label="Unidade de medida"
                options={Object.entries(INGREDIENT_TYPES_MAP).map(
                  ([key, value]) => ({
                    name: value,
                    value: key
                  })
                )}
                blank
                value={unitMeasure}
                onChange={({ target }) => {
                  setUnitMeasure(target.value as INGREDIENT_TYPES)
                  setPriceMeasure('')
                }}
                defaultValue={''}
                rules={{ required: true }}
              />
              {unitMeasure && (
                <Select
                  className="col-md-3"
                  name="price_measure"
                  label="Medida do preço"
                  options={INGREDIENT_PRICE_MEASURE_OPTIONS[unitMeasure]}
                  blank
                  value={priceMeasure}
                  onChange={({ target }) => setPriceMeasure(target.value)}
                  defaultValue={''}
                />
              )}
              <InputContainer className="col-md-3">
                <label
                  htmlFor="price"
                  className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                >
                  Preço
                </label>
                <div>
                  <input
                    className="form-control form-control-solid"
                    name="price"
                    id="price"
                    value={priceInput}
                    onChange={e => {
                      const value = genericMaskWithTwoZeroWithPoint(
                        e.target.value
                      )
                      setPriceInput(value)
                    }}
                    onKeyPress={event => {
                      const regex = /^[0-9.]+$/
                      if (!regex.test(event.key)) event.preventDefault()
                    }}
                  />
                </div>
              </InputContainer>
              <InputContainer className="col-md-3">
                <label
                  htmlFor={'correction_percentage'}
                  className="col-form-label fw-bold fs-6form-label fw-bold fs-6"
                >
                  Correção %
                </label>
                <div>
                  <input
                    className="form-control form-control-solid"
                    name="correction_percentage"
                    value={correctionPercentage}
                    onChange={e => {
                      const value = genericMaskWithTwoZero(e.target.value)
                      setCorrectionPercentage(value)
                    }}
                    onKeyPress={event => {
                      const regex = /^[0-9.]+$/
                      if (!regex.test(event.key)) event.preventDefault()
                    }}
                  />
                </div>
              </InputContainer>
              <Textarea
                name="description"
                className=" col-md-12"
                label="Descrição"
                rows={3}
                rules={{ required: true }}
              />
            </div>
          </FormContainer>
          <div className="card-footer d-flex justify-content-end py-6 px-9">
            <button type="submit" className="btn btn-primary">
              Salvar
            </button>
          </div>
        </div>
      </>
    </Form>
  )
}
